import { Routes } from "@angular/router";
import { authGuard } from "./core/auth/auth.guard";

export const routes: Routes = [
  {
    path: "authenticate",
    loadComponent: () =>
      import("./modules/auth/auth.component").then((m) => m.AuthComponent),
  },
  {
    path: "logout",
    loadComponent: () =>
      import("./modules/logout/logout.component").then(
        (m) => m.LogoutComponent
      ),
  },
  // { path: 'login', loadComponent: () => import('./modules/login/login.component').then(m => m.LoginComponent) },
  {
    path: "cadastro",
    loadComponent: () =>
      import("./modules/register/register.component").then(
        (m) => m.RegisterComponent
      ),
  },
  {
    path: "pagamento",
    loadComponent: () =>
      import("./modules/payment/payment.component").then(
        (m) => m.PaymentComponent
      ),
  },
  //{ path: '', redirectTo: 'conta', pathMatch: 'full' },
  {
    path: "",
    loadChildren: () =>
      import("./layout/main/main.module").then((m) => m.MainModule),
    canActivate: [authGuard],
  },
  { path: "**", redirectTo: "login" },
];
